<template>
    <div class="container">
        <div class="row">
            <heading>{{ $t('admin_user.menuName') }}
            </heading>
        </div>
        <div class="row">
            <div class="card col-12">
                <div class="card-body">
                    <div class="form-group">
                        <label class="">{{ $t('admin_user.fields.email') }}</label>
                        <input type="text" v-model="data.email" class="form-control"/>
                        <small class="text-danger" v-if="errors['email']">{{ errors['email'][0] }}</small>
                    </div>
                    <div class="form-group">
                        <label class="">{{ $t('admin_user.fields.username') }}</label>
                        <input type="text" v-model="data.username" class="form-control"/>
                        <small class="text-danger" v-if="errors['username']">{{ errors['username'][0] }}</small>
                    </div>
                    <div class="form-group">
                        <label class="">{{ $t('admin_user.fields.password') }}</label>
                        <input type="password" v-model="data.password" class="form-control"/>
                        <small class="text-danger" v-if="errors['password']">{{ errors['password'][0] }}</small>
                    </div>

                    <button class="btn btn-primary float-right" @click="store">{{ $t('core.actions.save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'AdminUserCreadit',
        data: () => {
            return {
                errors: [],
                data: {
                    email: null,
                    username: null,
                    password: null,
                },
            }
        },
        methods: {
            store () {
                axios.post('/admin-user', this.data).then((response) => {
                    window.location.href = '/admin-user?success'
                }).catch((err) => {
                    this.errors = err.response.data.errors
                })
            },
        },
    }
</script>
